import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Modal from "react-modal";
import Header2 from "../../common/Header2";
import { clearLocalStorage } from "../../common/helpers/Utils";
import { actionLogout } from "../../common/redux/actions/";
import DynaLogo from "../../assets/img/aye-loader.gif";
import * as qs from "query-string";
import { MonoButton, useMono } from 'react-mono-js';

import "../../assets/css/main.css";
import Logo from "../../assets/img/nav.svg";
import SilverPlan from "../../assets/img/silver.png";
import GoldPlan from "../../assets/img/gold.png";
import PlatinumPlan from "../../assets/img/Plat.png";
import FlexiPlan from "../../assets/img/Flex.png";
import PlanBlk from "../../assets/img/plan-blk.png";
import freeImg from "../../assets/img/free.png";
import newImg from "../../assets/img/new.png";
import mostImg from "../../assets/img/most.png";
import hoverImg from "../../assets/img/hover.png";
import OrdinaryPlan from "../../assets/img/ordinary.png";
import Verified from "../../assets/img/verified.png";
import Close from "../../assets/img/close.png";
import CONSTANTS from "../../common/helpers/Constants";
import {
  actionGetPlans,
  actionBuyPlan,
  actionOrdinaryPlan,
} from "../../common/redux/actions";
import {
  formatNumber,
  getLocalStorage,
  setLocalStorage,
} from "../../common/helpers/Utils";
import { showErrorToast } from "../../common/helpers/Toastr";
import trustFundApiService from "../../common/api/ApiService";
import axios from "axios";

class TrustPlans extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fromRegister: 0,
      loader: false,
      isChosen1: false,
      isChosen2: false,
      isChosen3: false,
      isChosen4: false,
      isChosen5: false,

      selectedPlanId: "",
      flexiFrequencies: [],
      pf_pl_text: "",
      con_amount: 500,
      con_duration: "3",
      membership_fee: 0.0,
    };
    this.logout = this.logout.bind(this);
    this.getFlexiFrequencies = this.getFlexiFrequencies.bind(this);
    this.selectPlan = this.selectPlan.bind(this);
    this.getPlans = this.getPlans.bind(this);
  }

  logout = () => {
    const _this = this;
    clearLocalStorage(function () {
      _this.props.history.push("/");
      _this.props.actionLogout();
    });
  };

  componentDidMount() {
    console.log(this.props.history.location.state);
    // this.setState({
    //   loader: true,
    // });
    console.log(this.props.history);
    if (
      this.props.history.location.state &&
      this.props.history.location.state.id
    ) {
      setLocalStorage("planId", this.props.history.location.state.id);
    }

    this.getFlexiFrequencies();
    // window.history.pushState(null, document.title, window.location.href);
    // window.addEventListener("popstate", function (event) {
    //   window.history.pushState(null, document.title, window.location.href);
    // });
    const { location } = this.props;
    if (location) {
      const parsed = qs.parse(location.search);

      console.log(parsed);

      console.log(location.pathname.includes("trxref=1&reference=2"));
      console.log(location);

      if (parsed.reference && parsed.trxref) {
        console.log("location");

        this.setState(
          {
            loader: true,
          },
          () => {
            console.log("load", this.state.loader);
            this.paymentProcess();
          }
        );
      } else if (location.pathname.includes("trxref=1&reference=2")) {
        this.setState(
          {
            loader: true,
          },
          () => {
            console.log("load", this.state.loader);
            this.paymentProcess();
          }
        );
      }
    }

    console.log(
      this.props.userData &&
        this.props.userData.u_id &&
        this.props.userData.u_tfp
    );
    console.log(
      this.props.userData,
      this.props.userData.u_id,
      this.props.userData.u_tfp,
      this.props.userData.u_id
    );

    if (getLocalStorage("fromRegister") === 1) {
      this.setState({
        fromRegister: 1,
      });
    } else if (
      this.props.userData &&
      this.props.userData.u_id &&
      this.props.userData.u_tfp_pin
      // this.props.userData.u_tfp
      // this.props.userData.u_plan_id &&
      // this.props.userData.u_plan_name
    ) {
      this.props.history.push("/dashboard");
    } else {
      this.props.history.push("/trustplans");
    }

    // if (location && location.state) {
    //   let fromRegister = location.state.fromRegister;
    //   if (fromRegister === 1) {
    //     this.setState({
    //       fromRegister: 1
    //     });
    //   }
    // } else if (
    //   this.props.userData &&
    //   this.props.userData.u_id &&
    //   this.props.userData.u_plan_id &&
    //   this.props.userData.u_plan_name
    // ) {
    //   this.props.history.push('/dashboard');
    // } else {
    //   this.props.history.push('/trustplans');
    // }
    this.getPlans();
  }

  getPlans = () => {
    this.props.actionGetPlans();
  };

  selectPlan = (type, val) => {
    console.log(this.state.selectedPlanId);
    setLocalStorage("planId", this.state.selectedPlanId);
    let data;
    if (type == "subscribeFlexiPlan") {
      data = {
        flexi_type: val,
        con_amount: this.state.con_amount,
        pf_pl_text: this.state.pf_pl_text,
        planid: this.state.selectedPlanId,
        page_response: "0",
      };
    } else {
      data = {
        planid: this.state.selectedPlanId.toString(),
        page_response: "0",
      };
    }

    if (this.state.selectedPlanId) {
      console.log(data);
      if (val !== 1) {
        this.setState({
          loader: true,
        });
      }
      trustFundApiService(type, data)
        .then((response) => {
          if (response.data.status === "success") {
            let result = response.data.data;
            console.log(result);

            if (val == 1) {
              console.log(response);
              this.setState({
                membership_fee: response.data.data.membership_fee,
                loader: false,
              });
            } else {
              if (result.authurl) {
                let authURL = result.authurl;
                window.location.href = authURL;
              }
              if (result.u_tfp_pin) {
                console.log("yes");
                this.props.actionOrdinaryPlan(result).then((resp) => {
                  this.props.history.push("/dashboard");
                });
              }
            }
          } else {
            this.setState({
              loader: false,
              con_amount:
                this.state.pf_pl_text == "Daily" &&
                this.state.con_amount > 10000
                  ? Math.floor(this.state.con_amount / 10)
                  : this.state.pf_pl_text == "Weekly" &&
                    this.state.con_amount > 100000
                  ? Math.floor(this.state.con_amount / 10)
                  : this.state.pf_pl_text == "Monthly" &&
                    this.state.con_amount > 500000
                  ? Math.floor(this.state.con_amount / 10)
                  : this.state.con_amount,
            });
          }
        })
        .catch((err) => {
          this.setState({
            loader: false,
          });
          console.log(err);
        });
    }
    // this.props.history.push('/carddetails');
  };
  getFlexiFrequencies() {
    this.setState({
      loader: true,
    });
    trustFundApiService("getFlexiFrequencies").then((response) => {
      if (response.data.status === "success") {
        this.setState({
          loader: false,
          flexiFrequencies: response.data.data,
          pf_pl_text: response.data.data[0].pf_pl_text,
        });
      } else {
        this.setState({
          loader: false,
        });
      }
    });
  }
  handleFlexiChange = (e) => {
    console.log(e.target.value);
    console.log(e.target.name);

    var isnum =
      e.target.name == "con_amount" ? /^\d+$/.test(e.target.value) : true;

    this.setState(
      {
        [e.target.name]:
          e.target.name == "con_amount"
            ? e.target.value.replace(/[^0-9]/g, "")
            : e.target.value,
      },
      () => {
        // if (isnum && this.state.con_amount > 199) {
        this.selectPlan("subscribeFlexiPlan", 1);
        // }
      }
    );
  };
  toggleModal1 = (id) => {
    this.setState({
      selectedPlanId: id,
      isChosen1: !this.state.isChosen1,
    });
  };
  toggleModal2 = (id) => {
    this.setState({
      selectedPlanId: id,
      isChosen2: !this.state.isChosen2,
    });
  };
  toggleModal3 = (id) => {
    this.setState({
      selectedPlanId: id,
      isChosen3: !this.state.isChosen3,
    });
  };
  toggleModal4 = (id) => {
    console.log(id);

    this.setState({
      selectedPlanId: id,
      isChosen4: !this.state.isChosen4,
    });
  };
  toggleModal5 = (id) => {
    this.setState({
      con_amount: "",
      membership_fee: 0.0,
      selectedPlanId: id,
      isChosen5: !this.state.isChosen5,
    });
  };

  bankTransfer = (planId) => {
    setLocalStorage("planId", planId);
    this.props.history.push("/transfer");
  };

  paymentProcess = () => {
    console.log("paymentProcesspaymentProcess22222");

    let _this = this;
    _this.setState({
      loader: true,
    });
    trustFundApiService("paymentProcess2").then((response) => {
  
      if (response.data.status === "success") {
        let result = response.data.data;
        console.log(response);
        if (result && result.pr_response) {
          let isSuccess = result.pr_response.status;
          if (isSuccess === true) {
            let paymentData = {
              planid: getLocalStorage("planId")
                ? getLocalStorage("planId")
                : this.state.selectedPlanId,
              payment_data: result.pr_response,
            };
            _this.setState({
              loader: true,
            });
            console.log("Loader Loader");

            this.props
              .actionBuyPlan(paymentData)
              .then((response) => {
                if (response.data.status === "success") {
                  if (getLocalStorage("referalKey")) {
                    console.log("dddd");
                    this.referTFP();
                  } else {
                    _this.setState({
                      loader: false,
                    });
                    _this.props.history.push({
                      pathname: "/trustpartner",
                      state: { fromRegister: _this.state.fromRegister },
                    });
                  }
                } else {
                  _this.setState({
                    loader: false,
                  });
                  _this.props.history.push({
                    pathname: "/trustpartner",
                    state: { fromRegister: this.state.fromRegister },
                  });
                }
              })
              .catch((err) => {
                _this.setState({
                  loader: false,
                });
                console.log(err);
              });
          } else {
            showErrorToast("your transaction failed, please try again later");
          }
        } else {
          console.log("payment response not caught");
        }
      } else {
        _this.setState({
          loader: false,
        });
      }
    });
    // .catch((err) => {
    //   _this.setState({
    //     loader: false,
    //   });
    // });
  };

  referTFP = () => {
    let tfp_code = getLocalStorage("referalKey");
    let tfp_relationship = CONSTANTS.TP_RELATION.FRIEND;

    if (tfp_code && tfp_relationship) {
      let data = {
        u_relationship: tfp_relationship,
        u_tfp_code: "TFP" + tfp_code,
      };

      trustFundApiService("referTrustPartner", data)
        .then((response) => {
          if (response.data.status === "success") {
            this.updateProcess();
            this.setState({
              loader: false,
            });
            setTimeout(
              function () {
                this.props.history.push({
                  pathname: "/dashboard",
                  state: { fromRegister: this.state.fromRegister },
                });
              }.bind(this),
              3000
            );
          } else {
            this.props.history.push({
              pathname: "/trustpartner",
              state: { fromRegister: this.state.fromRegister },
            });
            this.setState({
              loader: false,
            });
          }
        })
        .catch((err) => {
          this.setState({
            loader: false,
          });
          console.log(err);
        });
    }
  };

  updateProcess = () => {
    let data = {
      type: "both",
    };

    trustFundApiService("updateRegisterProcess", data);
  };
  textReturn(a) {
    let text = "";
    if (a == "Daily") {
      text = " (Debited Weekly)";
    } else {
      text = "";
    }
    return text;
  }

  connectMono = (userData, plan) => {
    this.setState({
      loader: true,
    });
    setLocalStorage("planId", plan.pl_plan_id);
    
    const data = {
        planid: plan.pl_plan_id.toString(),
        page_response: "0",
      };
    

    const options = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'mono-sec-key': 'live_sk_qa3fPWIaJYLPposVL4RM', //LIVE KEY
        // 'mono-sec-key': 'test_sk_KKCypz3LwE736xTxgQz4', //TEST KEY
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        amount: plan.pl_weekly_saving+'00',
        type: 'recurring-debit',
        interval: 'weekly',
        duration: 52,
        description: 'food',
        reference: userData.u_email+"-plan-payment-"+ Date(),
        redirect_url: 'https://www.etrustfund.ng/monowebhook.php',
        meta: {user: userData.u_email},
      })
    };
   
    trustFundApiService("paymentProcess1", data)
        .then((response) => {
          if (response.data.status === "success") {
            let result = response.data.data;
            console.log(result);
            fetch('https://api.withmono.com/v1/payments/initiate', options)
            .then(response => response.json())
            .then(response => {
              console.log(response);
              if(response.payment_link){
                window.location.href = response.payment_link;
              }
            })
            .catch(err => console.error(err));
          }
        })
        .catch((err) => {
          this.setState({
            loader: false,
          });
          console.log(err);
        });
  }

  connectNewPaystack = (userData, plan) => {
    this.setState({
      loader: true,
    });
    console.log(plan.pl_plan_id)
    setLocalStorage("planId", plan.pl_plan_id);
    
    const data = {
        planid: plan.pl_plan_id.toString(),
        page_response: "0",
      };

    
      const options = {
        port: 443,
        method: 'POST',
        headers: {
          Accept: 'application/json',
          // Authorization: 'Bearer sk_test_29e89500626fb6946e597c75c4eba7c1b40c4984', // TEST KEY
          Authorization: 'Bearer sk_live_b82a9234d2e8b8b7baf953b20f7c960c3369e085', //LIVE KEY
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email: userData.u_email,
          amount: plan.pl_weekly_saving,
          // plan: "PLN_9qkan3jhxsfyph6", // CHECK TEST PLAN WEBHOOK
          // plan: "PLN_z0tvjyhoij891m8", // CHECK TEST LIVE WEBHOOK
          // plan: plan.pl_plan_id == 3 ? "PLN_qrwbuyufzuhdd7r" : plan.pl_plan_id == 2 ? "PLN_3h9doyg9b2dy2lk" : "PLN_m4giovsi0hrtvkr", // TEST PLANS
          plan: plan.pl_plan_id == 3 ? "PLN_wvawrygq65vak72" : plan.pl_plan_id == 2 ? "PLN_nulqve536iv8yu7" : "PLN_rp1sppn60ph125h", //LIVE PLANS
        })
      };
   
    trustFundApiService("paymentProcess1", data)
        .then((response) => {
          if (response.data.status === "success") {
            let result = response.data.data;
            console.log(result);
            fetch('https://api.paystack.co/transaction/initialize', options)
            .then(response => response.json())
            .then(response => {
              console.log(response);
              if(response.data.authorization_url){
                window.location.href = response.data.authorization_url;
              }
            })
            .catch(err => console.error(err));
          }
        })
        .catch((err) => {
          this.setState({
            loader: false,
          });
          console.log(err);
        });
  }


  connectNewPaystackFlexi = (userData, plan) => {
    this.setState({
      loader: true,
    });
    console.log(plan.pl_plan_id)
    setLocalStorage("planId", plan.pl_plan_id);
    
    const data = {
        flexi_type: 2,
        con_amount: this.state.con_amount,
        pf_pl_text: this.state.pf_pl_text,
        pf_pl_duration: this.state.con_duration,
        planid: this.state.selectedPlanId,
        page_response: "0",
      };

    
      const options = {
        port: 443,
        method: 'POST',
        headers: {
          Accept: 'application/json',
          // Authorization: 'Bearer sk_test_29e89500626fb6946e597c75c4eba7c1b40c4984', // TEST KEY
          Authorization: 'Bearer sk_live_b82a9234d2e8b8b7baf953b20f7c960c3369e085', //LIVE KEY
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email: userData.u_email,
          amount: this.state.con_amount,
          // plan: 'PLN_qrwbuyufzuhdd7r'
          plan: this.state.con_amount == 100000 &&  this.state.pf_pl_text == 'Monthly' ? "PLN_3uoy8ai0n5bjojc" : this.state.con_amount == 100000 &&  this.state.pf_pl_text == 'Weekly' ? "PLN_v5l1x2uys6vp716" : this.state.con_amount == 100000 &&  this.state.pf_pl_text == 'Daily' ? "PLN_0bgi47m2nc8w36e" : this.state.con_amount == 50000 &&  this.state.pf_pl_text == 'Monthly' ? "PLN_1cb23szg9bqm8h7" : this.state.con_amount == 50000 &&  this.state.pf_pl_text == 'Weekly' ? "PLN_0xakw1sihui5ug4" : this.state.con_amount == 50000 &&  this.state.pf_pl_text == 'Daily' ? "PLN_6yi23paje4pabgs" : this.state.con_amount == 20000 &&  this.state.pf_pl_text == 'Monthly' ? "PLN_twn8cs1f6bk9w96" : this.state.con_amount == 20000 &&  this.state.pf_pl_text == 'Weekly' ? "PLN_xv5w3r33jyy8q84" : this.state.con_amount == 20000 &&  this.state.pf_pl_text == 'Daily' ? "PLN_fcttp655lklmhh0" : this.state.con_amount == 10000 &&  this.state.pf_pl_text == 'Monthly' ? "PLN_48mmb8v60lhlyw3" : this.state.con_amount == 10000 &&  this.state.pf_pl_text == 'Weekly' ? "PLN_w33qivyg1clynma" : this.state.con_amount == 10000 &&  this.state.pf_pl_text == 'Daily' ? "PLN_tx5hb6yowwa42ci" : this.state.con_amount == 5000 &&  this.state.pf_pl_text == 'Monthly' ? "PLN_nvb0u8uqn8mca5n" : this.state.con_amount == 5000 &&  this.state.pf_pl_text == 'Weekly' ? "PLN_idr9jmxy8dd8dw8" : this.state.con_amount == 5000 &&  this.state.pf_pl_text == 'Daily' ? "PLN_p2yevbkr8q832lu" : this.state.con_amount == 2000 &&  this.state.pf_pl_text == 'Monthly' ? "PLN_ksvwrkhaj33dwqw" : this.state.con_amount == 2000 &&  this.state.pf_pl_text == 'Weekly' ? "PLN_8xv6xpfw3ezklae" : this.state.con_amount == 2000 &&  this.state.pf_pl_text == 'Daily' ? "PLN_xjhixexpktucuor" : this.state.con_amount == 1000 &&  this.state.pf_pl_text == 'Monthly' ? "PLN_u8dcz5w1uirdiiu" : this.state.con_amount == 1000 &&  this.state.pf_pl_text == 'Weekly' ? "PLN_2wkcd6nk3iujmkg" : this.state.con_amount == 1000 &&  this.state.pf_pl_text == 'Daily' ? "PLN_xwu1wlyeuc4v5gt" : this.state.con_amount == 500 &&  this.state.pf_pl_text == 'Monthly' ? "PLN_lve1v146mxb60kq" : this.state.con_amount == 500 &&  this.state.pf_pl_text == 'Weekly' ? "PLN_5meo679bckosmes" : this.state.con_amount == 500 &&  this.state.pf_pl_text == 'Daily' ? "PLN_97q447tuhin8rko" : "PLN_97q447tuhin8rko", // LIVE PLANS
        })
      };
   
    trustFundApiService("subscribeFlexiPlan", data)
        .then((response) => {
          if (response.data.status === "success") {
            let result = response.data.data;
            console.log(result);
            fetch('https://api.paystack.co/transaction/initialize', options)
            .then(response => response.json())
            .then(response => {
              console.log(response);
              if(response.data.authorization_url){
                window.location.href = response.data.authorization_url;
              }
            })
            .catch(err => console.error(err));
          }
        })
        .catch((err) => {
          this.setState({
            loader: false,
          });
          console.log(err);
        });
  }

  render() {
    const { planData, userData, flexiFrequencies } = this.props;

    return (
      <div>
        <section
          id="planTop"
          className="uk-width-1-1@m"
          data-uk-height-viewport
        >
          <Header2 />
          <div className="container-main">
            {this.state.loader ? (
              <div className="spinner-wrapper">
                <div className="spinner">
                  <img src={DynaLogo} alt="" />
                </div>
              </div>
            ) : (
              ""
            )}
            <div className="">
              <div className="plan-select plan-select-view">
                <ul>
                  {getLocalStorage("planId")
                    ? this.props.planData.map((plan, index) => (
                        <div>
                          {plan.pl_plan_id == getLocalStorage("planId") ? (
                            <li
                              key={plan.pl_plan_id}
                              className="plan-select-width"
                            >
                              <div className="plan-select-left">
                                <div
                                  className="card-trst plan-card pln-selected-card uk-text-center"
                                  key={plan.id}
                                >
                                  <div>
                                    {plan.pl_plan_name == "BASIC" ? (
                                      <img
                                        src={freeImg}
                                        className="tag-img"
                                        alt=""
                                      />
                                    ) : plan.pl_plan_name == "FLEXI" ? (
                                      <img
                                        src={newImg}
                                        className="tag-img"
                                        alt=""
                                      />
                                    ) : plan.pl_plan_name == "PLATINUM" ? (
                                      <img
                                        src={mostImg}
                                        className="tag-img"
                                        alt=""
                                      />
                                    ) : null}
                                  </div>
                                  <div className="uk-text-center">
                                    {plan.pl_plan_name == "BASIC" ? (
                                      <img
                                        src={OrdinaryPlan}
                                        className="pln-img"
                                        alt=""
                                      />
                                    ) : plan.pl_plan_name != "BASIC" ? (
                                      <img
                                        src={PlanBlk}
                                        className="pln-img"
                                        alt=""
                                      />
                                    ) : null}
                                    <h6 className="pln-name">
                                    {plan.pl_plan_name == 'ORDINARY' ? 'BASIC':  plan.pl_plan_name } <br />
                                      MEMBERSHIP
                                    </h6>
                                  </div>
                                  <img
                                    src={hoverImg}
                                    className="hover-plan-select"
                                    alt=""
                                  />
                                </div>
                                <div className="uk-text-center">
                                  {plan.pl_plan_name === "BASIC" ? (
                                    <div>
                                      {/* <span className="uk-text-bold theme-color">
                                        {" "}
                                        Annual Membership Fee:{" "}
                                      </span>
                                      <br />
                                      <span className="uk-text-bold">
                                        {formatNumber(plan.pl_registration)}
                                      </span>
                                      <br /> */}
                                      <span className="uk-text-bold theme-color">
                                        {" "}
                                        Weekly Savings:{" "}
                                      </span>
                                      <br />
                                      <span className="uk-text-bold">
                                        Not Applicable
                                      </span>
                                      <br />
                                      <span className="uk-text-bold theme-color">
                                        {" "}
                                        Loans:{" "}
                                      </span>
                                      <br />
                                      <span className="uk-text-bold">
                                        Not Accessible
                                      </span>
                                    </div>
                                  ) : plan.pl_plan_name === "FLEXI" ? (
                                    <div>
                                      {/* <span className="uk-text-bold theme-color">
                                        {" "}
                                        Annual Membership Fee:{" "}
                                      </span>
                                      <br />
                                      <span className="uk-text-bold">
                                        {formatNumber(plan.pl_registration)}
                                      </span>
                                      <br /> */}
                                      <span className="uk-text-bold theme-color">
                                        {" "}
                                        Weekly Savings:{" "}
                                      </span>
                                      <br />
                                      <span className="uk-text-bold">
                                        {formatNumber(plan.pl_weekly_saving)}
                                      </span>
                                    </div>
                                  ) : (
                                    <div>
                                      {/* <span className="uk-text-bold theme-color">
                                        {" "}
                                        Annual Membership Fee:{" "}
                                      </span>
                                      <br />
                                      <span className="uk-text-bold">
                                        ₦{formatNumber(plan.pl_registration)}
                                      </span>
                                      <br /> */}
                                      <span className="uk-text-bold theme-color">
                                        {" "}
                                        Weekly Savings:{" "}
                                      </span>
                                      <br />
                                      <span className="uk-text-bold">
                                        ₦{formatNumber(plan.pl_weekly_saving)}
                                      </span>
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div className="plan-select-right">
                                <span className="uk-text-lead uk-text-bold">
                                  {" "}
                                  Other Benefits:
                                </span>
                                <br />
                                <div class="uk-column-1-2">
                                  <p>
                                    <ul>
                                      <li className="theme-color">
                                        - Weekly Earnings
                                      </li>
                                    </ul>
                                    {plan && plan.planbenefits.length > 0
                                      ? plan.planbenefits.map(
                                          (benifit, index) => (
                                            <ul>
                                              <li
                                                key={index}
                                                className="theme-color"
                                              >
                                                - {benifit.pb_text}
                                              </li>
                                            </ul>
                                          )
                                        )
                                      : null}
                                    <br />
                                    {this.state.fromRegister === 0 ? (
                                      <div className="clear uk-text-center choose-btn remove-margin-top">
                                        <Link to="/">
                                          <span className="uk-button pln-btn return-btn">
                                            Return Home
                                          </span>
                                        </Link>
                                        <Link
                                          to="/register"
                                          className="uk-button pln-btn prog-button"
                                        >
                                          Register
                                        </Link>
                                      </div>
                                    ) : (
                                      <div className="clear uk-text-center choose-btn remove-margin-top">
                                        <Link onClick={this.logout}>
                                          <span className="uk-button pln-btn return-btn">
                                            Return Home
                                          </span>
                                        </Link>
                                        {plan.pl_plan_name == "SILVER" ? (
                                          <a
                                            //onClick={this.selectPlan.bind( this, plan.pl_plan_id)}
                                            onClick={() =>
                                              this.toggleModal1(plan.pl_plan_id)
                                            }
                                            className="uk-button prog-button"
                                          >
                                            Get Started{" "}
                                            <span uk-icon="icon: chevron-right"></span>
                                          </a>
                                        ) : plan.pl_plan_name == "GOLD" ? (
                                          <a
                                            //onClick={this.selectPlan.bind( this, plan.pl_plan_id)}
                                            onClick={() =>
                                              this.toggleModal2(plan.pl_plan_id)
                                            }
                                            className="uk-button prog-button"
                                          >
                                            Get Started{" "}
                                            <span uk-icon="icon: chevron-right"></span>
                                          </a>
                                        ) : plan.pl_plan_name == "PLATINUM" ? (
                                          <a
                                            //onClick={this.selectPlan.bind( this, plan.pl_plan_id)}
                                            onClick={() =>
                                              this.toggleModal3(plan.pl_plan_id)
                                            }
                                            className="uk-button prog-button"
                                          >
                                            Get Started{" "}
                                            <span uk-icon="icon: chevron-right"></span>
                                          </a>
                                        ) : plan.pl_plan_name == "ORDINARY" ? (
                                          <a
                                            //onClick={this.selectPlan.bind( this, plan.pl_plan_id)}
                                            onClick={() =>
                                              this.toggleModal4(plan.pl_plan_id)
                                            }
                                            className="uk-button prog-button"
                                          >
                                            Get Started{" "}
                                            <span uk-icon="icon: chevron-right"></span>
                                          </a>
                                        ) : plan.pl_plan_name == "FLEXI" ? (
                                          <a
                                            onClick={() =>
                                              this.toggleModal5(plan.pl_plan_id)
                                            }
                                            className="uk-button prog-button"
                                          >
                                            Get Started{" "}
                                            <span uk-icon="icon: chevron-right"></span>
                                          </a>
                                        ) : null}
                                        <br />
                                        <br />

                                        <Modal
                                          className="uk-card uk-card-default uk-margin uk-width-1-2 u-modal uk-position-center animated fadeIn"
                                          isOpen={this.state.isChosen1}
                                          onRequestClose={this.toggleModal1}
                                        >
                                          <div className="uk-text-center uk-margin-right uk-margin-left">
                                            <h3 className="uk-text-lead theme-color">
                                              Select Payment Method
                                            </h3>
                                            {/* <MonoButton {...config} className="uk-button dash-button" text="Setup with Bank Account" /> */}
                                            {/* <a
                                              onClick={()=>this.connectMono(userData, plan)}
                                              className="uk-button dash-button"
                                            >
                                              Setup with Bank Account
                                            </a>
                                            
                                            <span className="modal-text">
                                              <br/><img width="10" src={Verified} />{" "}
                                              <i>AVAILABLE BANKS: Zenith Bank, FCMB, First Bank, Access Bank</i>
                                            </span>
                                            <br />
                                            <br /> */}
                                            <a
                                              // onClick={this.selectPlan.bind(
                                              //   this,
                                              //   "paymentProcess1"
                                              // )}
                                              onClick={()=>this.connectNewPaystack(userData, plan)}
                                              className="uk-button dash-button"
                                            >
                                              Setup with Bank Card{" "}
                                              <span uk-icon="icon: credit-card;"></span>
                                            </a>
                                            <br />
                                            <br />
                                           {/*  <span className="modal-text">
                                              <img width="10" src={Verified} />{" "}
                                              <i>
                                                To access Dashboard instantly
                                                and for seamless weekly
                                                contributions
                                              </i>
                                            </span>
                                            <br />
                                            <br />
                                            OR
                                            <br />
                                            <br />
                                            <a
                                              // onClick={this.bankTransfer.bind(
                                              //   this,
                                              //   // plan.pl_plan_id
                                              //   1
                                              // )}
                                              className="uk-button button-out"
                                            >
                                              Connect Bank Account
                                            </a> 
                                            <br />
                                            <span className="modal-text">
                                              <i>
                                                This will require your bank account details
                                              </i>
                                            </span>
                                            OR
                                            <br />
                                              <br /> */}
                                            <a
                                              onClick={this.bankTransfer.bind(
                                                this,
                                                // plan.pl_plan_id
                                                1
                                              )}
                                              className="uk-button button-out"
                                            >
                                              Pay via Bank Transfer
                                            </a>
                                            {/*<span className="modal-text">
                                              <i>
                                                This method may take up to 24hrs
                                                to access dashboard
                                                <br /> and a proof of paymemt
                                                may be required.
                                              </i>
                                              </span>*/}
                                            <br />
                                            <br />
                                            <a
                                              onClick={this.toggleModal1}
                                              className="uk-position-relative link uk-position-z-index theme-color"
                                            >
                                              <img
                                                src={Close}
                                                className="close-icon"
                                                alt="close"
                                              />
                                            </a>
                                          </div>
                                        </Modal>
                                        <Modal
                                          className="uk-card uk-card-default uk-margin uk-width-1-2 u-modal uk-position-center animated fadeIn"
                                          isOpen={this.state.isChosen2}
                                          onRequestClose={this.toggleModal2}
                                        >
                                          <div className="uk-text-center uk-margin-right uk-margin-left">
                                            <h3 className="uk-text-lead theme-color">
                                              Select Payment Method
                                            </h3>
                                            {/* <MonoButton {...config} className="uk-button dash-button" text="Setup with Bank Account" /> */}
                                            {/* <a
                                              onClick={()=>this.connectMono(userData, plan)}
                                              className="uk-button dash-button"
                                            >
                                              Setup with Bank Account
                                            </a>
                                            
                                            <span className="modal-text">
                                            <br/><img width="10" src={Verified} />{" "}
                                              <i>AVAILABLE BANKS: Zenith Bank, FCMB, First Bank, Access Bank</i>
                                            </span>
                                            <br />
                                            <br /> */}
                                            <a
                                              // onClick={this.selectPlan.bind(
                                              //   this,
                                              //   "paymentProcess1"
                                              // )}
                                              
                                              onClick={()=>this.connectNewPaystack(userData, plan)}
                                              className="uk-button dash-button"
                                            >
                                              Setup with Bank Card{" "}
                                              <span uk-icon="icon: credit-card;"></span>
                                            </a>
                                            {/* <br />
                                            <span className="modal-text">
                                              <img width="10" src={Verified} />{" "}
                                              <i>
                                                To access Dashboard instantly
                                                and for seamless weekly
                                                contributions
                                              </i>
                                            </span>
                                            <br />
                                            <br />
                                            OR
                                            <a
                                              // onClick={this.bankTransfer.bind(
                                              //   this,
                                              //   // plan.pl_plan_id
                                              //   1
                                              // )}
                                              className="uk-button button-out"
                                            >
                                              Connect Bank Account
                                            </a> */}
                                            <br />
                                            <br />
                                            <a
                                              onClick={this.bankTransfer.bind(
                                                this,
                                                // plan.pl_plan_id
                                                2
                                              )}
                                              className="uk-button button-out"
                                            >
                                              Pay via Bank Transfer
                                            </a>
                                            {/* <br />
                                            <span className="modal-text">
                                              <i>
                                                This method may take up to 24hrs
                                                to access dashboard
                                                <br /> and a proof of paymemt
                                                may be required.
                                              </i>
                                            </span> */}
                                            <br />
                                            <br />
                                            <a
                                              onClick={this.toggleModal2}
                                              className="uk-position-relative link uk-position-z-index theme-color"
                                            >
                                              <img
                                                src={Close}
                                                className="close-icon"
                                                alt="close"
                                              />
                                            </a>
                                          </div>
                                        </Modal>

                                        <Modal
                                          className="uk-card uk-card-default uk-margin uk-width-1-2 u-modal uk-position-center animated fadeIn"
                                          isOpen={this.state.isChosen3}
                                          onRequestClose={this.toggleModal3}
                                        >
                                          <div className="uk-text-center uk-margin-right uk-margin-left">
                                            <h3 className="uk-text-lead theme-color">
                                              Select Payment Method
                                            </h3>
                                            {/* <MonoButton {...config} className="uk-button dash-button" text="Setup with Bank Account" /> */}
                                            {/* <a
                                              onClick={()=>this.connectMono(userData, plan)}
                                              className="uk-button dash-button"
                                            >
                                              Setup with Bank Account
                                            </a>
                                            
                                            <span className="modal-text">
                                            <br/><img width="10" src={Verified} />{" "}
                                              <i>AVAILABLE BANKS: Zenith Bank, FCMB, First Bank, Access Bank</i>
                                            </span>
                                            <br />
                                            <br /> */}
                                            <a
                                              // onClick={this.selectPlan.bind(
                                              //   this,
                                              //   "paymentProcess1"
                                              // )}
                                              onClick={()=>this.connectNewPaystack(userData, plan)}
                                              className="uk-button dash-button"
                                            >
                                              Setup with Bank Card{" "}
                                              <span uk-icon="icon: credit-card;"></span>
                                            </a>
                                            {/* <br />
                                            <span className="modal-text">
                                              <img width="10" src={Verified} />{" "}
                                              <i>
                                                To access Dashboard instantly
                                                and for seamless weekly
                                                contributions
                                              </i>
                                            </span>
                                            <br />
                                            <br />
                                            OR */}
                                            <br />
                                            <br />
                                            <a
                                              onClick={this.bankTransfer.bind(
                                                this,
                                                // plan.pl_plan_id
                                                3
                                              )}
                                              className="uk-button button-out"
                                            >
                                              Pay via Bank Transfer
                                            </a>
                                            {/* <br />
                                            <span className="modal-text">
                                              <i>
                                                This method may take up to 24hrs
                                                to access dashboard
                                                <br /> and a proof of paymemt
                                                may be required.
                                              </i>
                                            </span> */}
                                            <br />
                                            <br />
                                            <a
                                              onClick={this.toggleModal3}
                                              className="uk-position-relative link uk-position-z-index theme-color"
                                            >
                                              <img
                                                src={Close}
                                                className="close-icon"
                                                alt="close"
                                              />
                                            </a>
                                          </div>
                                        </Modal>

                                        <Modal
                                          className="uk-card uk-card-default uk-margin uk-width-1-2 u-modal uk-position-center animated fadeIn"
                                          isOpen={this.state.isChosen4}
                                          onRequestClose={this.toggleModal4}
                                        >
                                          <div className="uk-text-center uk-margin-right uk-margin-left">
                                            <h3 className="uk-text-lead theme-color">
                                              Hurray!!! No Payment Required!
                                            </h3>
                                            <a
                                              onClick={() =>
                                                this.selectPlan(
                                                  "subscribeOrdinaryPlan"
                                                )
                                              }
                                              className="uk-button dash-button"
                                            >
                                              Subscribe to Free Plan
                                            </a>
                                            <br />
                                            <span className="modal-text">
                                              <img width="10" src={Verified} />{" "}
                                              <i>
                                                Your Dashboard will be created
                                                in few minutes
                                              </i>
                                            </span>
                                            <br />
                                            <br />

                                            <a
                                              onClick={this.toggleModal4}
                                              className="uk-position-relative link uk-position-z-index theme-color"
                                            >
                                              <img
                                                src={Close}
                                                className="close-icon"
                                                alt="close"
                                              />
                                            </a>
                                          </div>
                                        </Modal>

                                        <Modal
                                          className="uk-card uk-card-default uk-margin uk-width-1-2 u-modal uk-position-center animated fadeIn"
                                          isOpen={this.state.isChosen5}
                                          onRequestClose={this.toggleModal5}
                                        >
                                          <div className="uk-text-center uk-margin-right uk-margin-left">
                                            <h3 className="uk-text-lead theme-color">
                                              Set Flexi Amount & Frequency
                                            </h3>

                                            <div>
                                              {/* <div class="uk-width-1-1">
                                                <div className="uk-margin">
                                                  <div className="uk-form-controls">
                                                    <label className="uk-form-label-dash">
                                                      Contribution Amount (₦)
                                                    </label>
                                                    <input
                                                      className="uk-input"
                                                      name="con_amount"
                                                      type="text"
                                                      value={
                                                        this.state.con_amount
                                                      }
                                                      onChange={(e) =>
                                                        this.handleFlexiChange(
                                                          e
                                                        )
                                                      }
                                                    />
                                                  </div>
                                                </div>
                                              </div> */}
                                              
                                              <div class="uk-width-1-1">
                                                <div className="uk-margin">
                                                  <div className="uk-form-controls">
                                                    <label className="uk-form-label-dash">
                                                      Contribution Amount (₦)
                                                    </label>
                                                    <select
                                                      className="uk-select"
                                                      name="con_amount"
                                                      type="text"
                                                      value={
                                                        this.state.con_amount
                                                      }
                                                      onChange={(e) =>{
                                                        console.log(e.target.value)
                                                        this.setState( {
                                                            con_amount: e.target.value,
                                                          })
                                                        }
                                                      }
                                                    >
                                                      <option value="500">500</option>
                                                      <option value="1000">1000</option>
                                                      <option value="2000">2000</option>
                                                      <option value="5000">5000</option>
                                                      <option value="10000">10000</option>
                                                      <option value="20000">20000</option>
                                                      <option value="50000">50000</option>
                                                      <option value="100000">100000</option>
                                                    </select>
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="uk-width-1-1">
                                                <div className="uk-margin">
                                                  <div className="uk-form-controls">
                                                    <label className="uk-form-label-dash">
                                                      Select Frequency
                                                    </label>
                                                    <select
                                                      className="uk-select"
                                                      name="pf_pl_text"
                                                      type="text"
                                                      value={
                                                        this.state.pf_pl_text
                                                      }
                                                      onChange={(e) =>{
                                                        console.log(e.target.value)
                                                        this.setState( {
                                                            pf_pl_text: e.target.value,
                                                          })
                                                        }
                                                      }
                                                    >
                                                      <option value="Daily">Daily</option>
                                                      <option value="Weekly">Weekly</option>
                                                      <option value="Monthly">Monthly</option>
                                                      {/* {this.state
                                                        .flexiFrequencies &&
                                                        this.state.flexiFrequencies.map(
                                                          (resp, index) => {
                                                            return (
                                                              <option
                                                                key={index}
                                                                value={
                                                                  resp.pf_pl_text
                                                                }
                                                                id={resp.pf_id}
                                                              >
                                                                {resp.pf_pl_text +
                                                                  this.textReturn(
                                                                    resp.pf_pl_text
                                                                  )}
                                                              </option>
                                                            );
                                                          }
                                                        )} */}
                                                    </select>
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="uk-width-1-1">
                                                <div className="uk-margin">
                                                  <div className="uk-form-controls">
                                                    <label className="uk-form-label-dash">
                                                      Select Duration
                                                    </label>
                                                    <select
                                                      className="uk-select"
                                                      name="con_duration"
                                                      type="text"
                                                      value={
                                                        this.state.con_duration
                                                      }
                                                      onChange={(e) =>{
                                                        console.log(e.target.value)
                                                        this.setState( {
                                                            con_duration: e.target.value,
                                                          })
                                                        }
                                                      }
                                                    >
                                                      <option value="3">3 Months</option>
                                                      <option value="6">6 Months</option>
                                                      <option value="12">12 Months</option>
                                                      <option value="24">24 Months</option>
                                                      {/* {this.state
                                                        .flexiFrequencies &&
                                                        this.state.flexiFrequencies.map(
                                                          (resp, index) => {
                                                            return (
                                                              <option
                                                                key={index}
                                                                value={
                                                                  resp.pf_pl_text
                                                                }
                                                                id={resp.pf_id}
                                                              >
                                                                {resp.pf_pl_text +
                                                                  this.textReturn(
                                                                    resp.pf_pl_text
                                                                  )}
                                                              </option>
                                                            );
                                                          }
                                                        )} */}
                                                    </select>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>

                                            {/* <h4>
                                              Membership Fee:{" "}
                                              <span className="theme-color"></span>
                                              ₦{this.state.membership_fee}
                                            </h4> */}

                                            <a
                                              // onClick={this.selectPlan.bind(
                                              //   this,
                                              //   "subscribeFlexiPlan",
                                              //   2
                                              // )}
                                              onClick={()=>this.connectNewPaystackFlexi(userData, plan)}
                                              className="uk-button dash-button"
                                            >
                                              Setup with Bank Card{" "}
                                              <span uk-icon="icon: credit-card;"></span>
                                            </a>
                                            <br />
                                            {/*<span className="modal-text">
                                              <img width="10" src={Verified} />{" "}
                                              <i>
                                                Your Dashboard will be created
                                                in few minutes
                                              </i>
                                            </span>
                                            <br/><br/>OR<br/><br/>
                                                  <a
                                                    onClick={this.bankTransfer.bind(
                                                      this,
                                                      // plan.pl_plan_id
                                                      11
                                                    )}
                                                    className="uk-button button-out"
                                                  >
                                                    Pay via Bank Transfer
                                                  </a>
                                                <br/>
                                                <span className="modal-text"><i>This method may take up to 24hrs to access dashboard<br/> and a proof of paymemt may be required.</i></span>*/}
                                            <br />
                                            <br />
                                            <a
                                              onClick={this.toggleModal5}
                                              className="uk-position-relative link uk-position-z-index theme-color"
                                            >
                                              <img
                                                src={Close}
                                                className="close-icon"
                                                alt="close"
                                              />
                                            </a>
                                          </div>
                                        </Modal>
                                      </div>
                                    )}
                                  </p>
                                </div>
                              </div>
                            </li>
                          ) : null}
                        </div>
                      ))
                    : null}
                </ul>
              </div>
            </div>
          </div>
        </section>
        {/* FAQ Section */}
        <section id="faq" className="trst-plan-select-bg">
          <div>
            <ul>
              <p className="uk-text-lead text-white uk-text-bold other-margin">
                Other Plans:
              </p>
              {getLocalStorage("planId")
                ? this.props.planData.map((plan, index) => (
                    <div className="plan-select plan-switch">
                      {plan.pl_plan_id != getLocalStorage("planId") ? (
                        <li key={plan.pl_plan_id}>
                          <Link class="" to="/trustplans">
                            {/*<Link class="uk-accordion-title">*/}
                            <div
                              className="card-trst plan-card pln-select-card"
                              key={plan.id}
                              onClick={() => {
                                setLocalStorage("planId", plan.pl_plan_id);
                                console.log(plan.pl_plan_id);
                              }}
                            >
                              <div>
                                {plan.pl_plan_name == "BASIC" ? (
                                  <img
                                    src={freeImg}
                                    className="tag-img"
                                    alt=""
                                  />
                                ) : plan.pl_plan_name == "FLEXI" ? (
                                  <img
                                    src={newImg}
                                    className="tag-img"
                                    alt=""
                                  />
                                ) : plan.pl_plan_name == "PLATINUM" ? (
                                  <img
                                    src={mostImg}
                                    className="tag-img"
                                    alt=""
                                  />
                                ) : null}
                              </div>
                              <div className="uk-text-center">
                                {plan.pl_plan_name == "BASIC" ? (
                                  <img
                                    src={OrdinaryPlan}
                                    className="pln-img"
                                    alt=""
                                  />
                                ) : plan.pl_plan_name != "BASIC" ? (
                                  <img
                                    src={PlanBlk}
                                    className="pln-img"
                                    alt=""
                                  />
                                ) : null}
                                <h6 className="pln-name">
                                {plan.pl_plan_name == 'ORDINARY' ? 'BASIC':  plan.pl_plan_name } <br />
                                  MEMBERSHIP
                                </h6>
                              </div>
                              <img
                                src={hoverImg}
                                className="hover-plan"
                                alt=""
                              />
                            </div>
                          </Link>
                          <div class="uk-accordion-content"></div>
                        </li>
                      ) : null}
                    </div>
                  ))
                : null}
            </ul>
          </div>
          <br />
        </section>
        {/* End FAQ Section */}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { planData, userData } = state.user;
  return { planData, userData };
};

TrustPlans = connect(mapStateToProps, {
  actionGetPlans,
  actionBuyPlan,
  actionOrdinaryPlan,
})(TrustPlans);

export default TrustPlans;
